export const PAID_API_OPTIONS = Object.freeze({
  no: { label: 'No', value: 'no' },
  flat_fee: { label: 'Yes — flat fee', value: 'flat_fee' },
  api_call: { label: 'Yes — per API call', value: 'api_call' },
});
